export default function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50">
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-2 border-foreground-950/20 border-t-foreground-950 rounded-full animate-spin" />
        <span className="text-sm text-foreground-600 font-label tracking-widest uppercase">Loading</span>
      </div>
    </div>
  );
}